module.exports = __webpack_public_path__ + "img/right_dark_grey_arrow.663afeee.svg";